import api, { BOARDS } from "./api";

export const fetchEducationBoards = async () => {
  return await api.get(`${BOARDS}
  `);
};
